// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file mission/v1/mission.proto (package mission.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Case } from "../../case/v1/case_pb";
import { file_case_v1_case } from "../../case/v1/case_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { GuaranteeType } from "./guarantee_pb";
import { file_mission_v1_guarantee } from "./guarantee_pb";
import type { Price, TransportType } from "../../mobility/v1/common_pb";
import { file_mobility_v1_common } from "../../mobility/v1/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mission/v1/mission.proto.
 */
export const file_mission_v1_mission: GenFile = /*@__PURE__*/
  fileDesc("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", [file_case_v1_case, file_google_protobuf_timestamp, file_mission_v1_guarantee, file_mobility_v1_common]);

/**
 * MissionListFilter - optional filters for listing Missions.
 *
 * @generated from message mission.v1.MissionListFilter
 */
export type MissionListFilter = Message<"mission.v1.MissionListFilter"> & {
  /**
   * @generated from field: optional string case_number = 1;
   */
  caseNumber?: string;

  /**
   * @generated from field: optional string mission_id = 2;
   */
  missionId?: string;

  /**
   * @generated from field: optional string beneficiary_first_name = 3;
   */
  beneficiaryFirstName?: string;

  /**
   * @generated from field: optional string vehicle_plate = 4;
   */
  vehiclePlate?: string;

  /**
   * @generated from field: optional string phone = 5;
   */
  phone?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_after = 6;
   */
  createdAfter?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_before = 7;
   */
  createdBefore?: Timestamp;

  /**
   * @generated from field: optional string beneficiary_last_name = 8;
   */
  beneficiaryLastName?: string;
};

/**
 * Describes the message mission.v1.MissionListFilter.
 * Use `create(MissionListFilterSchema)` to create a new message.
 */
export const MissionListFilterSchema: GenMessage<MissionListFilter> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 0);

/**
 * ListMissionsRequest - request for listing Missions with optional pagination and filters.
 *
 * @generated from message mission.v1.ListMissionsRequest
 */
export type ListMissionsRequest = Message<"mission.v1.ListMissionsRequest"> & {
  /**
   * @generated from field: string page_cursor = 1;
   */
  pageCursor: string;

  /**
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: mission.v1.MissionListFilter filter = 3;
   */
  filter?: MissionListFilter;
};

/**
 * Describes the message mission.v1.ListMissionsRequest.
 * Use `create(ListMissionsRequestSchema)` to create a new message.
 */
export const ListMissionsRequestSchema: GenMessage<ListMissionsRequest> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 1);

/**
 * ListMissionsResponse - paginated list of Missions grouped by Case.
 *
 * @generated from message mission.v1.ListMissionsResponse
 */
export type ListMissionsResponse = Message<"mission.v1.ListMissionsResponse"> & {
  /**
   * @generated from field: repeated mission.v1.CaseMissionsSummary items = 1;
   */
  items: CaseMissionsSummary[];

  /**
   * @generated from field: string next_page_cursor = 2;
   */
  nextPageCursor: string;
};

/**
 * Describes the message mission.v1.ListMissionsResponse.
 * Use `create(ListMissionsResponseSchema)` to create a new message.
 */
export const ListMissionsResponseSchema: GenMessage<ListMissionsResponse> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 2);

/**
 * CaseMissionsSummary - a Case with the Missions attached to it.
 *
 * @generated from message mission.v1.CaseMissionsSummary
 */
export type CaseMissionsSummary = Message<"mission.v1.CaseMissionsSummary"> & {
  /**
   * @generated from field: case.v1.Case case = 1;
   */
  case?: Case;

  /**
   * @generated from field: repeated mission.v1.Mission missions = 2;
   */
  missions: Mission[];
};

/**
 * Describes the message mission.v1.CaseMissionsSummary.
 * Use `create(CaseMissionsSummarySchema)` to create a new message.
 */
export const CaseMissionsSummarySchema: GenMessage<CaseMissionsSummary> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 3);

/**
 * CreateMissionRequest - creates a Mission for a Case and GUARANTEE.
 *
 * @generated from message mission.v1.CreateMissionRequest
 */
export type CreateMissionRequest = Message<"mission.v1.CreateMissionRequest"> & {
  /**
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * @generated from field: mission.v1.GuaranteeType guarantee_type = 2;
   */
  guaranteeType: GuaranteeType;

  /**
   * @generated from field: repeated mobility.v1.TransportType enabled_transport_types = 3;
   */
  enabledTransportTypes: TransportType[];
};

/**
 * Describes the message mission.v1.CreateMissionRequest.
 * Use `create(CreateMissionRequestSchema)` to create a new message.
 */
export const CreateMissionRequestSchema: GenMessage<CreateMissionRequest> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 4);

/**
 * CreateMissionResponse - contains the created Mission
 *
 * @generated from message mission.v1.CreateMissionResponse
 */
export type CreateMissionResponse = Message<"mission.v1.CreateMissionResponse"> & {
  /**
   * @generated from field: mission.v1.Mission mission = 1;
   */
  mission?: Mission;
};

/**
 * Describes the message mission.v1.CreateMissionResponse.
 * Use `create(CreateMissionResponseSchema)` to create a new message.
 */
export const CreateMissionResponseSchema: GenMessage<CreateMissionResponse> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 5);

/**
 * GetMissionRequest - request for a Mission by ID.
 *
 * @generated from message mission.v1.GetMissionRequest
 */
export type GetMissionRequest = Message<"mission.v1.GetMissionRequest"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message mission.v1.GetMissionRequest.
 * Use `create(GetMissionRequestSchema)` to create a new message.
 */
export const GetMissionRequestSchema: GenMessage<GetMissionRequest> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 6);

/**
 * GetMissionResponse - contains a Mission.
 *
 * @generated from message mission.v1.GetMissionResponse
 */
export type GetMissionResponse = Message<"mission.v1.GetMissionResponse"> & {
  /**
   * @generated from field: mission.v1.Mission mission = 1;
   */
  mission?: Mission;
};

/**
 * Describes the message mission.v1.GetMissionResponse.
 * Use `create(GetMissionResponseSchema)` to create a new message.
 */
export const GetMissionResponseSchema: GenMessage<GetMissionResponse> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 7);

/**
 * Mission - root aggregate representing the assistance provided to the beneficiary for a Case.
 *
 * @generated from message mission.v1.Mission
 */
export type Mission = Message<"mission.v1.Mission"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;

  /**
   * @generated from field: string case_id = 2;
   */
  caseId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: mission.v1.GuaranteeType guarantee_type = 4;
   */
  guaranteeType: GuaranteeType;

  /**
   * @generated from field: mission.v1.MissionStatus status = 5;
   */
  status: MissionStatus;

  /**
   * @generated from field: repeated mission.v1.PrimaryTransportRef primary_transports = 6;
   */
  primaryTransports: PrimaryTransportRef[];

  /**
   * @generated from field: repeated mission.v1.GroundTransferRef ground_transfers = 7;
   */
  groundTransfers: GroundTransferRef[];

  /**
   * @generated from field: optional google.protobuf.Timestamp booked_at = 8;
   */
  bookedAt?: Timestamp;

  /**
   * @generated from field: optional mobility.v1.Price booking_amount = 9;
   */
  bookingAmount?: Price;

  /**
   * @generated from field: repeated mobility.v1.TransportType eligible_transport_types = 10;
   */
  eligibleTransportTypes: TransportType[];
};

/**
 * Describes the message mission.v1.Mission.
 * Use `create(MissionSchema)` to create a new message.
 */
export const MissionSchema: GenMessage<Mission> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 8);

/**
 * PrimaryTransportRef - reference to the Mission's primary transport.
 *
 * @generated from message mission.v1.PrimaryTransportRef
 */
export type PrimaryTransportRef = Message<"mission.v1.PrimaryTransportRef"> & {
  /**
   * @generated from field: string transport_id = 1;
   */
  transportId: string;

  /**
   * @generated from field: mobility.v1.TransportType transport_type = 2;
   */
  transportType: TransportType;

  /**
   * booking status of this primary transport
   *
   * @generated from field: mission.v1.TransportStatus status = 3;
   */
  status: TransportStatus;
};

/**
 * Describes the message mission.v1.PrimaryTransportRef.
 * Use `create(PrimaryTransportRefSchema)` to create a new message.
 */
export const PrimaryTransportRefSchema: GenMessage<PrimaryTransportRef> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 9);

/**
 * GroundTransferRef - reference to a ground transfer (pre- or post-primary transport taxi).
 *
 * @generated from message mission.v1.GroundTransferRef
 */
export type GroundTransferRef = Message<"mission.v1.GroundTransferRef"> & {
  /**
   * @generated from field: string ground_transfer_id = 1;
   */
  groundTransferId: string;

  /**
   * @generated from field: mission.v1.GroundTransferKind kind = 2;
   */
  kind: GroundTransferKind;

  /**
   * @generated from field: mobility.v1.TransportType transport_type = 3;
   */
  transportType: TransportType;

  /**
   * @generated from field: mission.v1.TransportStatus status = 4;
   */
  status: TransportStatus;
};

/**
 * Describes the message mission.v1.GroundTransferRef.
 * Use `create(GroundTransferRefSchema)` to create a new message.
 */
export const GroundTransferRefSchema: GenMessage<GroundTransferRef> = /*@__PURE__*/
  messageDesc(file_mission_v1_mission, 10);

/**
 * TransportStatus - applies to both primary and ground transfer transports.
 *
 * @generated from enum mission.v1.TransportStatus
 */
export enum TransportStatus {
  /**
   * @generated from enum value: TRANSPORT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSPORT_STATUS_NOT_BOOKED = 1;
   */
  NOT_BOOKED = 1,

  /**
   * temporary hold via PrebookingService, TTL applies
   *
   * @generated from enum value: TRANSPORT_STATUS_PREBOOKED = 2;
   */
  PREBOOKED = 2,

  /**
   * firm booking via TransportConfirmationService
   *
   * @generated from enum value: TRANSPORT_STATUS_CONFIRMED = 3;
   */
  CONFIRMED = 3,

  /**
   * @generated from enum value: TRANSPORT_STATUS_CANCELED = 4;
   */
  CANCELED = 4,
}

/**
 * Describes the enum mission.v1.TransportStatus.
 */
export const TransportStatusSchema: GenEnum<TransportStatus> = /*@__PURE__*/
  enumDesc(file_mission_v1_mission, 0);

/**
 * GroundTransferKind - position of a ground transfer relative to primary transports.
 * Booking order must be respected: PRE_TRANSPORT → BETWEEN_PRIMARY_TRANSPORTS → POST_TRANSPORT.
 *
 * @generated from enum mission.v1.GroundTransferKind
 */
export enum GroundTransferKind {
  /**
   * @generated from enum value: GROUND_TRANSFER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GROUND_TRANSFER_KIND_PRE_TRANSPORT = 1;
   */
  PRE_TRANSPORT = 1,

  /**
   * @generated from enum value: GROUND_TRANSFER_KIND_POST_TRANSPORT = 2;
   */
  POST_TRANSPORT = 2,

  /**
   * liaison between two consecutive primary transports (multimodal multi-leg)
   *
   * @generated from enum value: GROUND_TRANSFER_KIND_BETWEEN_PRIMARY_TRANSPORTS = 3;
   */
  BETWEEN_PRIMARY_TRANSPORTS = 3,
}

/**
 * Describes the enum mission.v1.GroundTransferKind.
 */
export const GroundTransferKindSchema: GenEnum<GroundTransferKind> = /*@__PURE__*/
  enumDesc(file_mission_v1_mission, 1);

/**
 * MissionStatus - lifecycle status of a Mission.
 * Phases: CREATED → SEARCHING → MOBILITY_SELECTED → PRIMARY_PREBOOKING → GROUND_TRANSFER_PREBOOKING → CONFIRMING → CONFIRMED → MOBILITY_IN_PROGRESS → PAST.
 *
 * @generated from enum mission.v1.MissionStatus
 */
export enum MissionStatus {
  /**
   * @generated from enum value: MISSION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MISSION_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: MISSION_STATUS_SEARCHING = 2;
   */
  SEARCHING = 2,

  /**
   * @generated from enum value: MISSION_STATUS_MOBILITY_SELECTED = 3;
   */
  MOBILITY_SELECTED = 3,

  /**
   * @generated from enum value: MISSION_STATUS_PRIMARY_PREBOOKING = 4;
   */
  PRIMARY_PREBOOKING = 4,

  /**
   * @generated from enum value: MISSION_STATUS_GROUND_TRANSFER_PREBOOKING = 5;
   */
  GROUND_TRANSFER_PREBOOKING = 5,

  /**
   * @generated from enum value: MISSION_STATUS_CONFIRMING = 6;
   */
  CONFIRMING = 6,

  /**
   * @generated from enum value: MISSION_STATUS_CONFIRMED = 7;
   */
  CONFIRMED = 7,

  /**
   * @generated from enum value: MISSION_STATUS_CANCELED = 8;
   */
  CANCELED = 8,

  /**
   * @generated from enum value: MISSION_STATUS_MOBILITY_IN_PROGRESS = 9;
   */
  MOBILITY_IN_PROGRESS = 9,

  /**
   * @generated from enum value: MISSION_STATUS_PAST = 10;
   */
  PAST = 10,

  /**
   * @generated from enum value: MISSION_STATUS_ERROR = 11;
   */
  ERROR = 11,
}

/**
 * Describes the enum mission.v1.MissionStatus.
 */
export const MissionStatusSchema: GenEnum<MissionStatus> = /*@__PURE__*/
  enumDesc(file_mission_v1_mission, 2);

/**
 * MissionService manages the Mission lifecycle.
 *
 * @generated from service mission.v1.MissionService
 */
export const MissionService: GenService<{
  /**
   * @generated from rpc mission.v1.MissionService.ListMissions
   */
  listMissions: {
    methodKind: "unary";
    input: typeof ListMissionsRequestSchema;
    output: typeof ListMissionsResponseSchema;
  },
  /**
   * Creates a Mission for a Case and GUARANTEE.
   *
   * @generated from rpc mission.v1.MissionService.CreateMission
   */
  createMission: {
    methodKind: "unary";
    input: typeof CreateMissionRequestSchema;
    output: typeof CreateMissionResponseSchema;
  },
  /**
   * Returns a Mission by ID.
   *
   * @generated from rpc mission.v1.MissionService.GetMission
   */
  getMission: {
    methodKind: "unary";
    input: typeof GetMissionRequestSchema;
    output: typeof GetMissionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_mission_v1_mission, 0);

